import { render, staticRenderFns } from "./roadWork.vue?vue&type=template&id=79832802&scoped=true"
import script from "./roadWork.vue?vue&type=script&lang=js"
export * from "./roadWork.vue?vue&type=script&lang=js"
import style0 from "./roadWork.vue?vue&type=style&index=0&id=79832802&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79832802",
  null
  
)

export default component.exports